import React from "react";
import PaginatedReport from "../../../../common/components/PaginatedReport";

export default function TeacherTurnOverByPositionChart({ data }) {
  return (
    <PaginatedReport
      data={data}
      rowsPerPage={20}
      renderTable={(paginatedData) => (
        <table style={{ borderCollapse: "collapse", width: "100%" }}>
          <thead>
            <tr style={{ backgroundColor: "#f9f9f9" }}>
              <th
                style={{
                  border: "1px solid #ddd",
                  padding: "10px 10px 10px 20px",
                  textAlign: "left",
                }}
              >
                Position
              </th>
              <th
                style={{
                  border: "1px solid #ddd",
                  padding: "10px",
                  textAlign: "center",
                }}
              >
                Turnovers
              </th>
            </tr>
          </thead>
          <tbody>
            {paginatedData.map((item, index) => (
              <tr
                key={index}
                style={{
                  backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#fff",
                }}
              >
                <td
                  style={{
                    border: "1px solid #ddd",
                    padding: "10px 10px 10px 20px",
                  }}
                >
                  {item.position}
                </td>
                <td
                  style={{
                    border: "1px solid #ddd",
                    textAlign: "center",
                    padding: "10px",
                  }}
                >
                  {item.total?.toLocaleString()}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    />
  );
}
